import { UserActivity } from "@/utils/validators/user-status.validator";
import clsx from "clsx";

const Activity = ({ activity }: { activity: UserActivity | undefined }) => {
	const _renderActivity = (activity: UserActivity) => {
		switch (activity) {
			case UserActivity.Idle:
				return {
					objStatus: {
						background: "bg-opus-yellow-300",
					},
				};
			case UserActivity.Offline:
				return {
					objStatus: {
						background: "bg-opus-gray-300",
					},
				};
			default:
				return {
					objStatus: {
						background: "bg-opus-green-300",
					},
				};
		}
	};
	return (
		<div
			className={clsx(
				"w-4 h-4 border border-white rounded-full",
				_renderActivity(activity as UserActivity).objStatus.background
			)}
		/>
	);
};

export default Activity;
